export const fontsOpenSans = [
  {
    style: "normal",
    urlSet: [{ format: "truetype", url: "/fonts/OpenSans-Light.ttf" }],
    weight: "300",
  },
  {
    style: "italic",
    urlSet: [{ format: "truetype", url: "/fonts/OpenSans-LightItalic.ttf" }],
    weight: "300",
  },
  {
    style: "normal",
    urlSet: [{ format: "truetype", url: "/fonts/OpenSans-Regular.ttf" }],
    weight: "400",
  },
  {
    style: "italic",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/OpenSans-RegularItalic.ttf",
      },
    ],
    weight: "400",
  },
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/OpenSans-SemiBold.ttf",
      },
    ],
    weight: "600",
  },
  {
    style: "italic",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/OpenSans-SemiBoldItalic.ttf",
      },
    ],
    weight: "600",
  },
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/OpenSans-Bold.ttf",
      },
    ],
    weight: "700",
  },
  {
    style: "italic",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/OpenSans-BoldItalic.ttf",
      },
    ],
    weight: "700",
  },

  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/OpenSans-ExtraBold.ttf",
      },
    ],
    weight: "800",
  },
  {
    style: "italic",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/OpenSans-ExtraBoldItalic.ttf",
      },
    ],
    weight: "800",
  },
];
